import React, { useContext, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { useTheme } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { ID, inEmittedState, Order } from '../../../../Models';
import OrderDialogTitle from './OrderDialogTitle';
import OrderDialogContent from './OrderDialogContent';
import { OrdersContext } from '../../../../services/Orders';

type OrderDialogProps = {
    orderId: ID | undefined;
    closeOrder: () => void;
};

function OrderDialog({ orderId, closeOrder }: OrderDialogProps) {
    const { ordersById } = useContext(OrdersContext);
    const order: Order | undefined = ordersById[orderId || ''];
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('xl'));
    const [loading, setLoading] = useState(false);
    const [currentView, setCurrentView] = useState<'whatsapp' | 'files' | 'historial'>(
        !order || inEmittedState(order) ? 'files' : 'whatsapp',
    );

    const onDone = () => {
        setLoading(false);
        closeOrder();
    };
    return (
        <Dialog
            scroll="paper"
            open={!!order}
            onClose={closeOrder}
            PaperProps={{
                sx: {
                    height: '95vh',
                    width: '100dvw',
                },
            }}
            maxWidth={false}
            fullScreen={fullScreen}>
            <OrderDialogTitle
                order={order}
                closeOrder={closeOrder}
                currentView={currentView}
                setCurrentView={setCurrentView}
            />

            <OrderDialogContent
                order={order}
                setLoading={setLoading}
                onDone={onDone}
                currentView={currentView}
            />
            <Backdrop
                sx={{ color: '#fff', zIndex: (_theme) => _theme.zIndex.drawer + 1 }}
                open={loading}
                transitionDuration={{ appear: 500, enter: 500, exit: 1000 }}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </Dialog>
    );
}

export default OrderDialog;
